import ColorUtil from "@/utils/ColorUtil"
import { makeStyles, Theme } from "@material-ui/core"
import { themeColors } from "letalkui"

const useStyles = makeStyles((theme: Theme) => ({
	tabsContainer: {
		width: "100%",
		[theme.breakpoints.up("md")]: {
			height: "100%",
			borderRight: `1px solid ${theme.palette.divider}`
		}
	},
	tabRoot: {
		textTransform: "none",
		justifyContent: "center",
		minWidth: 0
	},
	tabSelected: {
		fontWeight: theme.typography.fontWeightMedium as unknown as number
	},
	tabWrapper: {
		alignItems: "flex-start"
	},
	iconItem: {
		width: 33,
		height: 33,
		borderRadius: 20,
		display: "flex",
		justifyContent: "center",
		alignItems: "center"
	},
	titleText: {
		fontSize: 16
	},
	buttonPrimaryColorOutLined: {
		border: "1px solid",
		boxShadow: "none",
		borderColor: themeColors.colors.primary[100],
		fontWeight: 500,
		height: 30,
		...ColorUtil.getBackgroundAndContrastColor("transparent"),
		color: themeColors.getPrimaryColor(),
		letterSpacing: 0.4,
		animation: "$pulse 2s infinite",
		"&:hover": {
			animation: "none"
		}
	},
	multipleBlocks: {
		flexDirection: "column",
		gap: 10,
		paddingLeft: 32
	}
}))

export default useStyles
